import TooltipComponent from '@mui/material/Tooltip';
import Tooltip from 'components/Tooltip/HugeCasino';
import { useState } from 'react';
import { ProductData } from 'utils/types';
import { StyledSubProduct } from 'templates/Bundles/HugeCasino/style';
import { Box } from '@mui/material';

const TOOLTIP_TIMEOUT = 2000;

function BundleSubProduct({
  textFontColorHex,
  quantityDisplay,
  productType,
  quantity,
  index = 1,
  images,
  name = 'Product',
  rarityProductInfo,
  badgeText,
  itemRef,
  itemClassName = 'bundle',
  className = '',
  isFullWidth = true,
}: ProductData) {
  const [showTooltip, setShowTooltip] = useState(false);
  const [timeoutId, setTimeoutId] = useState<any>('');
  const tooltipIcon =
    'https://media.appcharge.com/media/641026dc506b12bf96a88368/tooltip.png';

  const toggleTooltip = (e: any) => {
    if (!rarityProductInfo) return;
    e.stopPropagation();
    setShowTooltip(!showTooltip);
    if (showTooltip) {
      itemRef.current.removeAttribute('style');
    } else {
      itemRef.current
        .closest(`.${itemClassName}`)
        .setAttribute('style', 'z-index: 100');
      if (timeoutId) clearTimeout(timeoutId);
      const timeout = setTimeout(() => {
        setShowTooltip(false);
        itemRef.current.closest(`.${itemClassName}`).removeAttribute('style');
      }, TOOLTIP_TIMEOUT);
      setTimeoutId(timeout);
    }
  };

  return (
    <StyledSubProduct
      color={textFontColorHex}
      isBadged={!!badgeText}
      badgeText={badgeText ? badgeText.substring(0, 2) : ''}
      isFullWidth={isFullWidth}
      className={className}
    >
      <Box className="content-container">
        <Box className="product-image-container" onClick={toggleTooltip}>
          {rarityProductInfo && (
            <TooltipComponent
              className="rarity-tooltip"
              enterTouchDelay={0}
              leaveTouchDelay={1700}
              title={
                <>
                  <Tooltip
                    productName={name}
                    quantityDisplay={quantityDisplay}
                    productType={productType}
                    productAmount={quantity as number}
                    tooltipText={rarityProductInfo.tooltipText}
                    rarityText={rarityProductInfo.rarityText}
                    stars={rarityProductInfo.stars}
                    display={true}
                    customPositioning={'relative'}
                    customStyles={{
                      marginTop: '-20px',
                      whiteSpace: 'normal',
                    }}
                  />
                </>
              }
              placement="bottom-start"
              componentsProps={{
                tooltip: {
                  sx: {
                    padding: '12px 6px',
                    background: 'transparent',
                    color: '#000000',
                    fontWeight: 'normal',
                  },
                },
              }}
            >
              <img src={tooltipIcon} alt="tooltip" className="tooltip" />
            </TooltipComponent>
          )}
          {badgeText && (
            <Box className="badge">
              <h4>{badgeText.substring(0, 2)}</h4>
            </Box>
          )}
          <div className="sub-product">
            <img className="product" src={images.product} alt="product" />
          </div>
        </Box>
        <Box>
          <p className="quantity">{quantityDisplay}</p>
          {rarityProductInfo && (
            <p className="tooltip">
              {rarityProductInfo.rarityText}{' '}
              {Array.from({ length: rarityProductInfo.stars }, (_, i) => {
                return (
                  <img
                    className="tooltip-img"
                    src="https://media.appcharge.com/media/641026dc506b12bf96a88368/star.png"
                    alt="star"
                    key={i}
                  />
                );
              })}
            </p>
          )}
        </Box>
      </Box>
    </StyledSubProduct>
  );
}

export default BundleSubProduct;
